module.exports = __webpack_public_path__ + "static/media/showcase.6db55cda.png";